import { theme, Typography } from "antd";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import routes from "../../../engine/routes";
import { ResponsablesList } from "../../../shared/container/Responsables/ResponsablesList/ResponsablesList";

export const InstitutionResponsables = () => {
  const {} = useSelector(state => state.addresses);
  const { institution } = useSelector(state => state.institution);

  const { id } = useParams();

  const {
    token: { colorPrimary },
  } = theme.useToken();

  return (
    <>
      <Typography.Title level={3} className={""}>
        {routes.institutions(id).responsables.title}
      </Typography.Title>
      {institution._id !== undefined && (
        <ResponsablesList institution={institution} />
      )}
    </>
  );
};
